import SubscriptionModel from '@models/account/SubscriptionModel';

export const FREE_PLAN_REFERENCE: Account_SubscriptionReference = 'default';

export const ON_DEMAND_PLAN_REFERENCE: Account_SubscriptionReference = 'on_demand';

export const isFreePlan = (plan?: SubscriptionModel) => plan?.reference === FREE_PLAN_REFERENCE;

export const isOnDemandPlan = (plan?: SubscriptionModel) => plan?.reference === ON_DEMAND_PLAN_REFERENCE;
